import { Divider, Grid, IconButton, Tooltip, Typography } from "@mui/material";
import React, { useState } from "react";

import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';
import ExitToAppRoundedIcon from '@mui/icons-material/ExitToAppRounded';
import ReceiptRoundedIcon from '@mui/icons-material/ReceiptRounded';


 

const PurchaseActionMenu = ({  selectedButtonName, setSelectedButtonName,handlecallProcess }) => {

    const [selectedButton, setSelectedButton] = useState(null);

    const handleButtonClick = (buttonName) => {
        setSelectedButton(buttonName);
        setSelectedButtonName(buttonName);
        
        handlecallProcess(buttonName);
    };
    return (

        <Grid container display="flex-start"  padding={0}>

            {/* Add Button */}
            {/* <Divider orientation="vertical" flexItem sx={{ marginLeft: "10px", marginRight: "10px" }} /> */}
            <Grid item md={0} ml="1px" mr="1px">
                <Tooltip title="Back to menu">
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <IconButton onClick={() => handleButtonClick('edit')}  >
                            <ModeEditOutlineOutlinedIcon style={{ fontSize:"18px" ,color: selectedButton === 'edit' ? "yellow" : "#009688" }} />
                            <Typography variant="h6" sx={{marginLeft:"5px"}}>Edit</Typography>
                        </IconButton>
                        {/* <span style={{ fontSize: 12 }}>Edit</span> */}
                    </div>
                </Tooltip>
            </Grid>
            <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />
            {/* Add Button */}
            <Grid item md={0} ml="1px" mr="1px">
                <Tooltip title="Send Mail">
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <IconButton onClick={() => handleButtonClick('Email')}>
                            <EmailOutlinedIcon style={{ fontSize:"18px" ,color: selectedButton === 'ParentRolls' ? "yellow" : "#009688" }} />
                            <Typography variant="h6" sx={{marginLeft:"5px"}}>Send Mail</Typography>
                        </IconButton>
                        {/* <span style={{ fontSize: 12 }}>Send Mail</span> */}
                    </div>
                </Tooltip>
            </Grid>
            <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />
            {/* Add Button */}
            <Grid item md={0} ml="5px" mr="5px">

                <Tooltip title="PDF/Print">
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <IconButton onClick={() => handleButtonClick('PDF')}>
                            <PictureAsPdfOutlinedIcon style={{fontSize:"18px" , color: selectedButton === 'PDF' ? "yellow" : "#009688" }} />
                            <Typography variant="h6" sx={{marginLeft:"5px"}}>PDF/Print</Typography>
                        </IconButton>
                        {/* <span style={{ fontSize: 12 }}>PDF/Print</span> */}
                    </div>
                </Tooltip>
            </Grid>
            <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />
            {/* Add Button */}
            <Grid item md={0} ml="5px" mr="5px">
                <Tooltip title="Receive">
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <IconButton onClick={() => handleButtonClick('Receive')}>
                            <ExitToAppRoundedIcon style={{fontSize:"18px" , color: selectedButton === 'Receive' ? "yellow" : "#009688" }} />
                            <Typography variant="h6" sx={{marginLeft:"5px"}}>Receive</Typography>
                        </IconButton>
                        {/* <span style={{ fontSize: 12 }}>Receive</span> */}
                    </div>
                </Tooltip>
            </Grid>
            <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />
            {/* Add Button */}
            <Grid item md={0} ml="5px" mr="5px">
                <Tooltip title="Convert to Bill">
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <IconButton onClick={() => handleButtonClick('Bill')}>
                            <ReceiptRoundedIcon style={{fontSize:"18px" , color: selectedButton === 'Bundles' ? "yellow" : "#009688" }} />
                            <Typography variant="h6" sx={{marginLeft:"5px"}}>Convert to Bill</Typography>
                        </IconButton>
                        {/* <span style={{ fontSize: 12 }}>Convert to Bill</span> */}
                    </div>
                </Tooltip>
            </Grid>
            <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />
             <Grid item md={0} ml="5px" mr="5px">
                <Tooltip title="Timeline">
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <IconButton onClick={() => handleButtonClick('timeline')}>
                            <ReceiptRoundedIcon style={{fontSize:"18px" , color: selectedButton === 'timeline' ? "yellow" : "#009688" }} />
                            <Typography variant="h6" sx={{marginLeft:"5px"}}>Timeline</Typography>
                        </IconButton>
                        {/* <span style={{ fontSize: 12 }}>Convert to Bill</span> */}
                    </div>
                </Tooltip>
            </Grid>
            <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />
           
            
        </Grid>



    )
};
export default PurchaseActionMenu;